/**
 * Cross-cutting endpoints: login, current user, quarter selector, sync status.
 */
import { Route, respond } from '../router';
import { DEFAULT_PERSONA, demoToken, personaByEmail, userJson } from '../personas';
import { allQuarters, currentQuarter } from '../clock';
import { syncStatus } from '../state';
import { currentUserJson } from './admin';

export const CORE_ROUTES: Route[] = [
    {
        method: 'POST',
        path: '/api/user/login_check',
        handler: ctx => {
            const persona = personaByEmail(ctx.body?.email);
            return { token: demoToken(persona), refresh_token: `demo-refresh-${persona.key}`, user: userJson(persona) };
        },
    },
    {
        method: 'POST',
        path: '/api/user/token_refresh',
        handler: ctx => {
            const key = String(ctx.body?.refresh_token || '').replace('demo-refresh-', '');
            const persona = personaByEmail(`${key}@`) ?? DEFAULT_PERSONA;
            return { token: demoToken(persona), refresh_token: `demo-refresh-${persona.key}` };
        },
    },
    {
        method: 'GET',
        path: '/api/v1/user/current',
        // While impersonating, echo back the exact account asked for: the app
        // re-fetches whenever the returned email differs, so falling back to a
        // persona here would loop forever.
        handler: ctx => (ctx.switchUser && ctx.switchUser.toLowerCase() !== ctx.persona.email ? currentUserJson(ctx.switchUser) : userJson(ctx.persona)),
    },
    {
        method: 'GET',
        path: '/api/quarters',
        handler: () => {
            const current = currentQuarter().key;
            return {
                quarters: allQuarters().map(q => ({ value: q.key, label: q.label, current: q.key === current })),
                current,
            };
        },
    },
    { method: 'GET', path: '/api/sync/status/:type', handler: ctx => syncStatus(ctx.params['type'], ctx.board) },
    { method: 'POST', path: '/api/msg/webpush', handler: () => respond({}) },
];
